import { REDUX_PROMPT_TYPES } from './action'

const {
  MATCH_LOADS,
  MATCH_TRUCKS,
  ASSIGN_LOADS,
  ASSIGN_TRUCKS,
  UPDATE_PLATES,
  PROMPTS,
  GENERATE_ORDER_DOC,
  MAIL_TEMPLATE,
  STATUS_UPDATE,
  REQUEST_UPDATE,
  SHOW_DOC, TRANSACTION_FIXED
} = REDUX_PROMPT_TYPES
const initialState = {
  loadToAssign: {},
  truckToAssign: {},
  loadToMatch: {},
  truckToMatch: {}
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case MATCH_LOADS:
      return {
        ...state,
        loadToMatch: action.payload
      }
    case MATCH_TRUCKS:
      return {
        ...state,
        truckToMatch: action.payload
      }
    case ASSIGN_LOADS:
      return {
        ...state,
        loadToAssign: action.payload
      }
    case ASSIGN_TRUCKS:
      return {
        ...state,
        truckToAssign: action.payload
      }
    case UPDATE_PLATES:
      return {
        ...state,
        updatePlates: action.payload
      }
    case PROMPTS:
      return {
        ...state,
        prompts: action.payload
      }
    case GENERATE_ORDER_DOC:
      return {
        ...state,
        generateDoc: action.payload
      }
    case MAIL_TEMPLATE:
      return {
        ...state,
        mailtemplate: action.payload
      }
    case STATUS_UPDATE:
      return {
        ...state,
        statusupdate: action.payload
      }
    case REQUEST_UPDATE:
      return {
        ...state,
        requestUpdate: action.payload
      }
    case SHOW_DOC:
      return {
        ...state,
        showDoc: action.payload
      }
    case TRANSACTION_FIXED:
      return {
        ...state,
        isTransactionFixed: action.payload
      }
    default:
      return state
  }
}
